<script setup lang="ts">
import { useHead } from '@unhead/vue';
useHead({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] });
</script>

<template>
  <div class="not-found">
    <div class="not-found-icon"><i class="fa-solid fa-bullseye" /></div>
    <h1>404</h1>
    <p>Page introuvable</p>
    <RouterLink to="/" class="btn btn-primary">Retour</RouterLink>
  </div>
</template>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 0.75rem;
  text-align: center;
}

.not-found-icon {
  font-size: 3rem;
  color: var(--primary);
  opacity: 0.3;
}

.not-found h1 {
  font-size: 4rem;
  font-weight: 700;
  color: var(--text-muted);
}

.not-found p {
  color: var(--text-muted);
  margin-bottom: 0.5rem;
}
</style>
